import Svg, { Mask, Path } from '@rd-core-svg/svg'
import type { FlagsSvgProps } from '../svg.types'

export const MastercardSmall = (props: FlagsSvgProps) => {
  return (
    <Svg width={36} height={24} viewBox="0 0 36 24" fill="none" {...props}>
      <Mask id="path-1-inside-1_22078_4018" fill="white">
        <Path d="M0 4C0 1.79086 1.79086 0 4 0H32C34.2091 0 36 1.79086 36 4V20C36 22.2091 34.2091 24 32 24H4C1.79086 24 0 22.2091 0 20V4Z" />
      </Mask>
      <Path
        d="M0 4C0 1.79086 1.79086 0 4 0H32C34.2091 0 36 1.79086 36 4V20C36 22.2091 34.2091 24 32 24H4C1.79086 24 0 22.2091 0 20V4Z"
        fill="white"
      />
      <Path
        d="M4 0V1H32V0V-1H4V0ZM36 4H35V20H36H37V4H36ZM32 24V23H4V24V25H32V24ZM0 20H1V4H0H-1V20H0ZM4 24V23C2.34315 23 1 21.6569 1 20H0H-1C-1 22.7614 1.23858 25 4 25V24ZM36 20H35C35 21.6569 33.6569 23 32 23V24V25C34.7614 25 37 22.7614 37 20H36ZM32 0V1C33.6569 1 35 2.34315 35 4H36H37C37 1.23858 34.7614 -1 32 -1V0ZM4 0V-1C1.23858 -1 -1 1.23858 -1 4H0H1C1 2.34315 2.34315 1 4 1V0Z"
        fill="#E6E6E6"
        mask="url(#path-1-inside-1_22078_4018)"
      />
      <Path
        d="M21.1097 6.49658H14.8904V17.5034H21.1097V6.49658Z"
        fill="#FF5F00"
      />
      <Path
        d="M15.2854 12C15.2844 10.94 15.5283 9.8936 15.9986 8.94013C16.469 7.98666 17.1534 7.15106 18.0001 6.4966C16.9516 5.68492 15.6923 5.18015 14.3662 5.03998C13.0402 4.89981 11.7008 5.12989 10.5013 5.70394C9.30173 6.27799 8.29036 7.17285 7.58279 8.28621C6.87522 9.39958 6.5 10.6865 6.5 12C6.5 13.3135 6.87522 14.6004 7.58279 15.7138C8.29036 16.8272 9.30173 17.722 10.5013 18.2961C11.7008 18.8701 13.0402 19.1002 14.3662 18.96C15.6923 18.8199 16.9516 18.3151 18.0001 17.5034C17.1534 16.8489 16.469 16.0133 15.9986 15.0599C15.5283 14.1064 15.2844 13.06 15.2854 12Z"
        fill="#EB001B"
      />
      <Path
        d="M29.5 12C29.5 13.3134 29.1249 14.6004 28.4173 15.7138C27.7098 16.8271 26.6985 17.722 25.4989 18.296C24.2994 18.8701 22.9601 19.1002 21.634 18.96C20.308 18.8199 19.0488 18.3151 18.0002 17.5034C18.8462 16.8483 19.5301 16.0125 20.0004 15.0592C20.4706 14.1059 20.715 13.0599 20.715 12C20.715 10.9401 20.4706 9.8941 20.0004 8.94077C19.5301 7.98745 18.8462 7.15172 18.0002 6.4966C19.0488 5.68492 20.308 5.18015 21.634 5.03998C22.9601 4.89981 24.2994 5.1299 25.4989 5.70396C26.6985 6.27801 27.7098 7.17287 28.4173 8.28623C29.1249 9.3996 29.5 10.6866 29.5 12Z"
        fill="#F79E1B"
      />
      <Path
        d="M28.8217 16.3376V16.1123H28.914V16.0664H28.679V16.1123H28.7713V16.3376H28.8217ZM29.2779 16.3376V16.0659H29.2059L29.123 16.2528L29.0402 16.0659H28.9681V16.3376H29.019V16.1327L29.0967 16.3094H29.1494L29.2271 16.1322V16.3376H29.2779Z"
        fill="#F79E1B"
      />
    </Svg>
  )
}
